/**
 * @typedef {"development" | "early_access" | "beta" | "production" | "maintenance"} ApplicationReleaseState
 */

/** @type {ApplicationReleaseState} */
export const APPLICATION_RELEASE_STATE = 'early_access';

export const TERMS_VERSION = '2026-07-11';
export const PRIVACY_VERSION = '2026-07-11';
export const EARLY_ACCESS_NOTICE_VERSION = '2026-07-11';

export const isEarlyAccess = (releaseState = APPLICATION_RELEASE_STATE) => (
  releaseState === 'early_access'
);

export const isProduction = (releaseState = APPLICATION_RELEASE_STATE) => (
  releaseState === 'production'
);

export const shouldShowReleaseStateNotice = (releaseState = APPLICATION_RELEASE_STATE) => (
  !isProduction(releaseState) && isEarlyAccess(releaseState)
);

export const RELEASE_STATE_LABELS = {
  earlyAccessChip: 'EARLY ACCESS',
  learnMore: 'Learn more',
};

export const RELEASE_STATE_MESSAGES = {
  globalBanner: 'JourneyBot is currently in Early Access. Features may change, and occasional errors, interruptions or data loss may occur.',
  tooltip: 'JourneyBot is still under active development.',
  contextual: 'Early Access: Keep an independent copy of important information before continuing.',
};
